import { ensureDefined } from '@avantia/client-and-server-utilities';
import { HpInputControlProps } from '../../../engineClient/types';
import { HpClaimsQuestionSetPageProps } from '../../questionSetForm/questionSetPageTypes';
import { WarningWidget } from './coverSummaryCustomControl';

interface WarningCustomControlProps extends HpInputControlProps {
  pageProps: HpClaimsQuestionSetPageProps;
  customData: WarningCustomData;
}

interface WarningCustomData {
  copyText: string;
}

//TODO: Move warning widget to parser as similar to info and help text
export function WarningCustomControl(props: WarningCustomControlProps): JSX.Element | null {
  const { data } = props;
  const { customData } = data;
  ensureDefined(customData, 'customData');
  const { copyText } = customData as unknown as WarningCustomData;

  return <WarningWidget warningText={copyText} />;
}
